<template>
	<div>
		<template>
			<el-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" @change="change"
				clearable transfer filterable>
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</template>
	</div>
</template>

<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {

		},
		data() {
			return {
				ready: false,
				options: [],

			}
		},
		created() {

		},
		watch: {

		},
		computed: {


		},

		methods: {
			list() {
				this.loading = true
				this.emunlist = []
				this.$api.emunlist.list().then((res) => {
					res.forEach((item)=>{
						this.options.push({
							value: item.field,
							label: item.field + '(' + item.name + ')'
						})
					})
				})
			},
		}
	}
</script>
